import { LitElement, html } from 'lit';
import styles from './styles';
/**
 * @slot - The element's content.
 *
 * @csspart base - The element's base container.
 */
export default class AmityekoTgBodyOne extends LitElement {
    render() {
        return html `<p part="base"><slot></slot></p>`;
    }
}
AmityekoTgBodyOne.styles = styles;
if (!customElements.get('amityeko-tg-body-one')) {
    customElements.define('amityeko-tg-body-one', AmityekoTgBodyOne);
}
//# sourceMappingURL=index.js.map